import {
    AdditionalProductType,
    FuelType,
    PhoneCountryCodeType,
    TransmissionType,
    VehicleConditionType,
    VehicleOptionType,
} from "@bus/models";

export interface SubmitAnswersRequest {
    transactionId?: string;
    volkswagenGroupPartnerIds?: string[];
    matchMakerAnswers?: IMatchMakerAnswers;
    contactDetails?: IPersonalData;
    selectedDealer?: string;
    currentStep: Step;
    isEditMode: boolean;
}

export interface IMatchMakerAnswers {
    conditions?: VehicleConditionType[];
    models?: string[];
    fuelTypes?: FuelType[];
    monthlyPayment?: number;
    hasDeposit?: boolean;
    deposit?: number;
    duration?: number;
    transmissionType?: TransmissionType[];
    minPower?: number;
    maxPower?: number;
    optionals?: VehicleOptionType[];
    contractType?: string[];
    kmsPerYear?: number;
    services?: AdditionalProductType[];
}

export interface IPersonalData {
    firstName: string;
    lastName: string;
    mobilePhoneCountryCode: PhoneCountryCodeType;
    mobilePhoneNumber: string;
    email: string;
    contactPreference: ContactOptionEnum | undefined;
}

export enum ContactOptionEnum {
    Phone = "Phone",
    Email = "Email",
}
export enum Step {
    START = "START",
    MM1 = "MM1",
    MM2 = "MM2",
    MM3 = "MM3",
    MM4 = "MM4",
    DEALER_SELECTION = "DEALER_SELECTION",
    CONTACT_DETAILS = "CONTACT_DETAILS",
    FINAL_CONFIRMATION = "FINAL_CONFIRMATION",
    FINAL_CONFIRMATION_PAGE = "CONFIRMATION_PAGE",
    ERROR_PAGE = "ERROR_PAGE",
}
